<template>
  <div class="coursePage">
    <div class="courseBox" v-for="list,idx in 3" :key="idx">
      <p class="courseTitle">
        热门领域分类 |
        <span class="courseTitleLevel" @click="openMoreFn">更多</span>
      </p>
      <ul class="classBox">
        <li class="classList" :class="[classActive == item ? 'classListActive' :'']" v-for="item,index in 5" :key="index">课程{{ item }}</li>
      </ul>
      <a-row :gutter="_isMobile() ? [0,20]:[20,20]">
        <a-col :xs="24" :sm="24" :md="6" v-for="item,index in 6" :key="index">
          <div class="courseList" @click="openDetailsFn(item)">
            <img src="../../assets/aice2/kec_image.png" class="courseImage" alt="">
            <p class="p1">课程名称</p>
            <p class="p2">作何</p>
            <div class="courseFooter">
              <div class="courserType" :style="{'background':backgroundList[Math.floor(Math.random() * backgroundList.length)]}">人文</div>
              <div class="courserOverview">
                <span v-for="v,i in 3" :key="i"><i v-if="v != 1">|</i> {{ v }}   </span>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
export default {
  mixins: [mixinDevice],
  name: "",
  components: {},
  data() {
    return {
      backgroundList:['#AE5DA1','#EC6941','#32B16C','#556FB5'],
      classActive:1,
    };
  },
  created() {},
  mounted() {},
  methods: {
    openMoreFn(){
      this.$router.push({path:'/course/list'})
    },
    openDetailsFn(item){
      this.$router.push({path:'/course/detail'})
    }
  },
};
</script>
<style lang='scss' scoped>
.coursePage {
  width: 100%;
  p{
    margin: 0;
  }
  ul,li{
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .courseList:hover {
    box-shadow: 2px 2px 6px 0px rgba(91, 106, 140, 0.36);
    background: #fff;
    border-radius: 10px;
  }
  .courseBox {
    width: 100%;
    margin-bottom: 80px;
    .courseList{
      width: 100%;
      height: auto;
      cursor: pointer;
      .courseFooter{
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        .courserType{
           height: 24px;
           width: auto;
           border-radius: 5px;
           background: #AE5DA1;
           color: #fff;
           line-height: 24px;
           font-size: 16px;
           padding: 0 6px;
        }
        .courserOverview{
          font-size: 16px;
          color: #666666;
        }
      }
      .courseImage{
        width: 100%;
        height: 180px;
        object-fit: cover;
        border-radius: 10px;
      }
      .p1{
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        padding: 14px 10px 6px 10px;
      }
      .p1:hover{
        color: #184DD5;
      }
      .p2{
        font-size: 16px;
        color: #666666;
        padding: 0 10px;
      }
    }
    .courseTitle{
      font-size: 22px;
      font-weight: 600;
      color: #333;
      text-align: left;
      .courseTitleLevel{
        font-size: 16px;
        cursor: pointer;
      }
    }
    .classBox{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      margin: 20px 0 16px 0;
      .classList{
        height: 30px;
        width: auto;
        padding: 0 10px;
        font-size: 16px;
        color: #999;
        line-height: 30px;
        border: 1px solid #999;
        border-radius: 15px;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .classList:hover{
        background: #184DD5;
        color: #fff;
        border-color: #184DD5;
      }
      .classListActive{
        background: #184DD5 !important;
        color: #fff !important;
        border-color: #184DD5 !important;
      }
    }
    
  }
}
</style>
